/**
 * A plugin to connect App and Backend using a bidirectional Websocket.
 *
 * Higher level wrapper of the websocketbridge.js as supplied by
 * Django-Channels. Can be used as this.$socketbridge in components or
 * directly via importing the singleton.
 */

// File copied from the Django-Channels 1.1.8 distribution, see:
// http://channels.readthedocs.io/en/1.x/javascript.html
import '@/django_channels_websocketbridge';

import bus from './bus';
import environment from './environment';
import i18n from './i18n';
import store from './store';

class SocketBridge {
  constructor() {
    this._bridge = null;
  }

  /**
   * Trigger a refetch of the processed Content.
   *
   * This will e.g. update the client so that the now-available video
   * preview is displayed instead of some placeholder image.
   */
  handleContentProcessed(action, stream) {
    if (action.name === 'content_processed') {
      // Notify listening components to refetch as needed.
      const content = action.content;
      bus.$emit('refetch-on-content-processed', content);
    }
  }

  /**
   * Connect to the Django-Channels Websocket Group for the App.
   *
   * This connection is used to e.g. push updates to the App about
   * Spots that have finished processing etc.
   */
  connect() {
    this.disconnect();

    this._bridge = new channels.WebSocketBridge();

    // The authtoken cookie is passed through the message headers
    // automatically and will be used to authenticate the User in the
    // channels backend.
    const socketUrl = environment.urls.websocket + 'app';
    console.log('[socketbridge] connecting to', socketUrl);

    this._bridge.connect(socketUrl);
    this._bridge.listen((action, stream) => {
      // Add any additional event handlers in here.
      this.handleContentProcessed(action, stream);
    });
  }

  disconnect() {
    if (this._bridge && this._bridge.socket) {
      this._bridge.socket.close();
      this._bridge = null;
    }
  }

  install(Vue, options) {
    Vue.prototype.$socketbridge = this;
  }
}

export default new SocketBridge();



// WEBPACK FOOTER //
// ./src/socketbridge.js